import styled from 'styled-components'

export const RoutesContainer = styled.div`
  margin-top: 35px;
`
